import {IUploadPauseController} from '@toolify/client/src/modules/files/upload/types/IUploadPauseController'
import {createUploadAbortError} from '@toolify/client/src/modules/files/upload/uploadInParts'

export function createUploadPauseController(): IUploadPauseController {
  let resumeResolvers: Array<() => void> = []

  const flushResumeResolvers = (): void => {
    const resolvers = resumeResolvers
    resumeResolvers = []
    for(const resolve of resolvers) {
      resolve()
    }
  }

  // the methods mutate through `this` so that writes go through the reactive proxy the task list wraps them in
  return {
    isPaused: false,
    // pausing only means anything for a part-addressed direct upload; the proxy path is a single
    // streaming request that cannot be resumed, so the ui must not offer it there
    isSupported: false,
    markSupported(this: IUploadPauseController, value: boolean): void {
      this.isSupported = value
      if(!value) {
        this.isPaused = false
        flushResumeResolvers()
      }
    },
    pause(this: IUploadPauseController): void {
      if(!this.isSupported) {
        return
      }
      this.isPaused = true
    },
    resume(this: IUploadPauseController): void {
      if(!this.isPaused) {
        return
      }
      this.isPaused = false
      flushResumeResolvers()
    },
    // parts already in flight are deliberately left to finish - aborting them would throw away
    // up to one part size of transferred bytes for nothing
    waitWhilePaused(this: IUploadPauseController, signal?: AbortSignal): Promise<void> {
      if(!this.isPaused) {
        return Promise.resolve()
      }
      return new Promise<void>((resolve, reject) => {
        if(signal?.aborted) {
          reject(createUploadAbortError())
          return
        }
        const onAbort = () => {
          resumeResolvers = resumeResolvers.filter(resolver => resolver !== onResume)
          reject(createUploadAbortError())
        }
        const onResume = () => {
          signal?.removeEventListener('abort', onAbort)
          resolve()
        }
        signal?.addEventListener('abort', onAbort, {once: true})
        resumeResolvers.push(onResume)
      })
    },
  }
}
